import React from "react";

const StripSection = () => {
  return (
    <div className="strip-section section">
      <div className="container">
        <ul className="strip_section-row">
          <li>
            <div className="strip-box">
              <div className="title">3 & 4 Bed Abodes </div>
              <div className="sub_title">Configuration</div>
            </div>
          </li>
          <li>
            <div className="strip-box">
              <div className="title">2 Acres </div>
              <div className="sub_title">Land Parcel</div>
            </div>
          </li>
          <li>
            <div className="strip-box">
              <div className="title">Revealing Soon</div>
              <div className="sub_title">Floors</div>
            </div>
          </li>
          <li>
            <div className="strip-box">
              <div className="title">Coming Soon</div>
              <div className="sub_title">Project Status</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default StripSection;
